import React, { useState } from 'react';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import CompSelectorModal from 'components/comps/selector/modal';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import PropertyComp from './property_comp';

import { put } from 'helpers/api';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export function PropertyComps({ coordinates, paths, propertyComps, type, onChange, onRemove, onReorder }) {
  const [showSelector, setShowSelector] = useState();

  let content;
  if (propertyComps.length) {
    content = (
      <div className="property-comps flex-fill bg-light border rounded">
        {propertyComps.map((propertyComp, index) => (
          <PropertyComp
            index={index}
            key={propertyComp.id}
            propertyComp={propertyComp}
            onRemove={onRemove}
            onReorder={onReorder}
          />
        ))}
      </div>
    );
  } else {
    content = (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Empty.Media>
        <Empty.Title>{`You have not selected any ${type} comps`}</Empty.Title>
      </Empty>
    );
  }

  async function save(comps) {
    const propertyComps = await put(paths.index, { comps, type });
    setShowSelector(false);
    onChange(propertyComps);
  }

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex justify-content-between align-items-center">
        <h6>{capitalize(type)} Comps</h6>
        <div
          className="d-flex align-items-center gap-2 clickable"
          name="edit"
          onClick={() => setShowSelector(true)}
        >
          <FontAwesomeIcon className="text-muted" icon={faEllipsisV} size="lg" />
          Edit {capitalize(type)} Comps
        </div>
      </div>

      {content}

      <CompSelectorModal
        coordinates={coordinates}
        defaultSelectedComps={propertyComps.map(propertyComp => propertyComp.researchComp)}
        show={showSelector}
        type={type}
        onCancel={() => setShowSelector(false)}
        onSave={save}
      />
    </div>
  );
}

PropertyComps.propTypes = {
  coordinates: PropTypes.object,
  paths: PropTypes.shape({
    index: PropTypes.string.isRequired,
  }).isRequired,
  propertyComps: PropTypes.arrayOf(PropTypes.shape({
    researchComp: PropTypes.object.isRequired,
  })).isRequired,
  type: PropTypes.oneOf(['lease', 'sale']).isRequired,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  onReorder: PropTypes.func,
};

export default reorderableList(PropertyComps);
